// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"24efebab","361":"f0da21ab","568":"d9af000d","767":"c796f7b3"}[chunkId] + ".chunk.js";
};